import React from 'react';
import { Loading } from '/imports/ui/Loading';

interface LoadingFillProps {
  caption?: string;
  className?: string;
}

export const LoadingFill = (props: LoadingFillProps) => (
  <div className={`loading-fill absolute z-100 flex h-full w-full flex-1 flex-col justify-around bg-page mobile:[&.loading-page]:top-nav-mobile ${props.className}`}>
    <Loading caption={props.caption} />
  </div>
);
